import type { ReactElement } from 'react'
import { useField } from 'formik'

import type { FormState } from './shared'
import { useTranslate } from '../../../utils/translate'

export function ThemeFilterTagsList(): ReactElement | null {
  const [, { value }, { setValue }] = useField<FormState['selectedTags']>('selectedTags')
  const t = useTranslate('interface', 'views.editorThemesView')

  return value.length ? (
    <>
      <button type="button" className="ep-theme-manager-filter-tags-clear" onClick={() => setValue([])}>
        {t('filtersTagList.clearAllButton.label')}
      </button>
      <ul className="ep-theme-manager-filter-tags-list">
        {value.map((tag) => (
          <li key={tag}>
            <span key={tag}>{t(`filters.attributes.${tag.split(':')[1]}`)}</span>
            <button
              type="button"
              onClick={() => {
                setValue(value.filter((selectedTag) => selectedTag !== tag))
              }}
            >
              <span>{t('filtersTagList.removeButton.accessibilityLabel')}</span>
            </button>
          </li>
        ))}
      </ul>
    </>
  ) : null
}
